import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { removeUser } from "../../redux/slice/authSlice";

function isAdminToken(token) {
  if (!token) return false;
  try {
    const decoded = jwtDecode(token);
    return decoded?.tokenType === "admin" && decoded?.role === "admin";
  } catch {
    return false;
  }
}

const AdminAuthCheck = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userToken } = useSelector((state) => state.user);

  useEffect(() => {
    if (!userToken) {
      navigate("/signin", { replace: true });
      return;
    }
    if (!isAdminToken(userToken)) {
      dispatch(removeUser());
      navigate("/signin", { replace: true });
    }
  }, [dispatch, navigate, userToken]);

  if (!userToken || !isAdminToken(userToken)) {
    return <Navigate to="/signin" replace />;
  }

  return children;
};

export default AdminAuthCheck;
export { isAdminToken };
